import { createEntityAdapter, EntityState } from '@ngrx/entity';
import {
    Contract2PlausibilitaetActions,
    Contract2PlausibilitaetActionTypes,
} from '../../actions/mdqx/contract2plausibilitaet.actions';
import { Contract2PlausibilitaetEntity } from '../../../entities/mdqx/contract2plausibilitaet.entity';

export interface Contract2PlausibilitaetState extends EntityState<Contract2PlausibilitaetEntity> {
    fetched: boolean;
}

export const CONTRACT2PLAUSIBILITAET_KEY = 'contract2Plausibilitaet';

const adapter = createEntityAdapter<Contract2PlausibilitaetEntity>({
    selectId: contract2Plausibilitaet => contract2Plausibilitaet.Id,
});

const initialState: Contract2PlausibilitaetState = adapter.getInitialState({
    fetched: false,
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export function contract2PlausibilitaetReducer(
    state = initialState,
    action: Contract2PlausibilitaetActions,
) {
    switch (action.type) {
        case Contract2PlausibilitaetActionTypes.GetContract2PlausibilitaetenResponse: {
            return adapter.setAll(action.Payload, { ...state, fetched: true });
        }

        case Contract2PlausibilitaetActionTypes.PostContract2PlausibilitaetResponse: {
            return adapter.addOne(action.Payload, state);
        }

        case Contract2PlausibilitaetActionTypes.DeleteContract2PlausibilitaetResponse: {
            return adapter.removeOne(action.Payload, state);
        }

        default: {
            return state;
        }
    }
}

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectAll } = adapter.getSelectors();

export const selectAllContract2Plausibilitaeten = selectAll;

export const selectContract2PlausibilitaetenFetched = (state: Contract2PlausibilitaetState) =>
    state.fetched;
